

<template>
<div id="map">
  
  <div class="grid-x grid-margin-x">
    
    <div class="small-12 medium-6 cell">
      <v-map ref="leafletmap" :zoom="zoom" :center="center" @dblclick="getMapData" @l-zoom="updateZoom" @l-moveend="getMapData">
        <v-tilelayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></v-tilelayer>
        <v-marker :lat-lng="marker" :icon="marker_icon"></v-marker>
      </v-map>
    </div>
    
    <div class="small-12 medium-6 cell">
      
      <div class="grid-x grid-margin-x">
        
        <div class="small-12 cell">
          <label class="address">
            <div class="form-label">Votre adresse&nbsp;:</div>
            
            <div class="input-group">
              
              <div class="dropdown" :class="{'open' : open}">
                <input type="text"
                       ref="search"
                       class="map-address-suggestion"
                       placeholder="Entrez votre adresse pour déterminer vos coordonnées géographiques"
                       v-model="searchText"
                       @input="searchChanged"
                       @keydown.enter="suggestionSelected(matches[highlightIndex], highlightIndex)"
                       @keydown.down="down"
                       @keydown.up="up"
                       @keydown.esc="setOpen(false)"
                       @blur="setOpen(false)"
                       v-on:placechanged="getAddressData"
                       >
                </input>
    
                <ul class="suggestion-list">
                  <li v-for="(suggestion, index) in matches"
                      :class="{'active' : index == highlightIndex}"
                      @mousedown.prevent
                      @click="suggestionSelected(suggestion, index)"
                      >
                    {{ suggestion[0] }}
                  </li>
                  <li class="powered-by">Source des données de géolocalisation : https://adresse.data.gouv.fr</li>
                </ul>
              </div>

              <span class="input-group-label">
                <button aria-label="Me localiser" v-on:click="getPositionFromGPS" class="get-gps" v-if="show_gps_button && !localization_is_blocked && !waiting_gps">
                  <i class="fas fa-location-arrow" title="Me localiser"></i>
                </button>
                <button aria-label="localisation en cours..."  class="get-gps" v-if="show_gps_button && !localization_is_blocked && waiting_gps">
                  <i class="fas fa-street-view" title="Localisation en cours…"></i>
                </button>
              </span>
            </div>
          </label>
          <span v-if="localization_is_blocked" class="error">
            <i class="fas fa-map"></i> Impossible d'obtenir votre position géographique, utilisez la carte.
          </span>
        </div>
        
        <div class="small-12 cell">
          
          <div class="latlon">
            <div class="grid-x grid-margin-x">
              <div class="small-10 cell">
                <h3>Coordonnées GPS</h3>
              </div>
              <div class="small-2 cell text-right">
                <a class="button-plus"  v-on:click="hideLatLon = !hideLatLon">
                  <span v-bind:class="{ hide: !hideLatLon }"><i class="fas fa-plus-square" title="Voir la latitude et longitude"></i></span>
                  <span v-bind:class="{ hide: hideLatLon }"><i class="fas fa-minus-square" title="Cacher la latitude et longitude"></i></span>
                </a>
              </div>
            </div>
          </div>
          
          <div v-bind:class="{ hide: hideLatLon }" id="lat_lon">

            
            <div class="form-label">Latitude&nbsp;:</div>
            <div class="input-group">
              <input v-model.number="latitude" type="number" @change="getLatLon" @input="setLatitudeFromField" min="-90" max="90">
              <span class="input-group-label">
                Lat.
              </span>
            </div>
            
            <div class="form-label">Longitude&nbsp;:</div>
            <div class="input-group">
              <input v-model.number="longitude" type="number" @change="getLatLon" @input="setLongitudeFromField" min="-180" max="180">
              <span class="input-group-label">
                Long.
              </span>
            </div>
            
          </div>
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</template>


<script>

import Vue2Leaflet from 'vue2-leaflet';
import _ from 'lodash'

import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'


export default {
    name: 'GetCoordinate',
    components: {
        'v-map': Vue2Leaflet.Map,
        'v-tilelayer': Vue2Leaflet.TileLayer,
        'v-marker': Vue2Leaflet.Marker,
    },
    props: [
        'initial_latitude',
        'initial_longitude',
    ],
    data () {
        return {
            zoom: 15,
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            prevent_empty_field: false,
            show_gps_button: true,
            localization_is_blocked: false,
            waiting_gps: false,
            hideLatLon: true,
            latitude_old: 45.7682549,
            longitude_old: 4.85963219999996,

            searchText: '',
            suggeredAddress: '',
            selectedOption: null,
            open: false,
            highlightIndex: 0,
            lastSearchText: '',

            
        }
    },
    mounted: function() {
        this.setPosition(
            {
                latitude: this.initial_latitude,
                longitude: this.initial_longitude
            }
        );
        if (!(navigator && navigator.geolocation)) {
            this.show_gps_button = false;
        }
        // this.getPositionFromGPS();
    },
    computed: {
            ...mapFields(
                [
                    'latitude',
                    'longitude',
                ]
            ),
            // ...mapState(
            //     [
            //         'latitude',
            //         'longitude',
            //     ]
            // ),
        center: function() {
            return [this.latitude, this.longitude];
        },
        marker: function() {
            if (this.latitude != NaN && this.longitude != NaN) {
                    if (this.latitude != undefined && this.longitude != undefined) {
                        return L.latLng(this.latitude, this.longitude);
                    }
            }
            return L.latLng(0,0);
        },
        marker_icon: function() {
            return new L.Icon(
                {
                    iconUrl: '/static/img/marker-icon-2x-blue.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    
                    // shadowUrl: 'static/img/marker-icon-2x-blue.pngleaf-shadow.png',
                    // shadowSize:   [50, 64], // size of the shadow
                    // shadowAnchor: [4, 62],  // the same for the shadow
                }
            )
        },
        matches: function() {
            let matches = {};
            let i = 1;
            for (let feature of this.suggeredAddress) {
                matches[i] = [feature.properties.label];
                i++;
            }
            return matches;
        },
    },
    methods: {
        ...mapMutations(
            [
                'setLatitude',
                'setLongitude',
                'setPosition',
            ]
        ),
        ...mapGetters(
            [
                'getLatitude',
                'getLongitude',
            ]
        ),
        setLatitudeFromField: function(value) {
            this.setLatitude(value.target.value);
        },
        setLongitudeFromField: function(value) {
            this.setLongitude(value.target.value);
        },
        getPositionFromGPS: function() {
            if (navigator && navigator.geolocation) {
                this.waiting_gps = true;
                var self = this;
                navigator.geolocation.getCurrentPosition(
                    function(location) {
                        console.log('GPS position: ', location.coords.latitude, location.coords.longitude, location.coords.accuracy);
                        self.zoom = 15;
                        self.setPosition(
                            {
                                latitude: location.coords.latitude,
                                longitude: location.coords.longitude
                            }
                        );
                        self.waiting_gps = false;
                        self.updateAddressFromLatLon();
                        // self.emitPosition();
                    },
                    function() {
                        console.log("Cannot get localization");
                        self.localization_is_blocked = true;
                        self.waiting_gps = false;
                    },
                    {
                        // enableHighAccuracy:true,
                        timeout:20000,
                        // maximumAge:600000,
                    }
                );
            }
            else {
                console.log("Cannot get localization from navigator");
                self.waiting_gps = false;
            }
        },
        updateAddressFromLatLon: function() {
            function debouncedUpdateAddressFromLatLon(obj) {
                obj.$http.get(
                    `https://api-adresse.data.gouv.fr/reverse/?lon=${obj.longitude}&lat=${obj.latitude}`
                ).then(
                    response => {
                        if (response.body.features.length >= 1) {
                            obj.searchText = response.body.features[0].properties.label;
                        };
                    }
                );
            }

            let debounceUpdate = _.debounce(debouncedUpdateAddressFromLatLon, 1500);
            debounceUpdate(this);
        },
        getHeight: function() {
            return this.$refs.app.clientHeight;
        },
        /**
         * When the location found
         * @param {Object} addressData Data of the found location
         * @param {Object} placeResultData PlaceResult object
         * @param {String} id Input container ID
         */
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData;
            this.prevent_empty_field = true;
            this.setPosition(
                {
                    latitude: addressData.latitude,
                    longitude: addressData.longitude
                }
            );
            // this.emitPosition();
        },
        getMapData: function (event) {
            if (this.prevent_empty_field) {
                this.prevent_empty_field = false;
                return;
            }
            var position = event.sourceTarget.getCenter()
            console.log("map moved to ", position);
            this.searchText = "";
            this.setPosition(
                {
                    latitude: position.lat,
                    longitude: position.lng
                }
            );
            this.updateAddressFromLatLon();
        },
        updateZoom: function(event) {
            this.zoom = event.target.getZoom();
        },
        getLatLon: function(val, oldVal) {
        },
        
        setOpen (isOpen) {
            this.open = isOpen
            
            if (this.open) {
                this.$refs.search.focus()
                this.lastSearchText = this.searchText
                this.searchText = ''
            } else if (this.searchText.trim() === '') {
                this.searchText = this.lastSearchText
            }
        },
        
        updateComponentWithValue (newValue) {
            if (Object.values(this.options).indexOf(newValue) > -1) {
                // Find the matching text for the supplied option value
                for (var text in this.options) {
                    if (this.options.hasOwnProperty(text)) {
                        if (this.options[text] === newValue) {
                            this.searchText = text
                        }
                    }
                }
            }
        },
        
        searchChanged () {
            if (this.searchText.length > 2) {
                this.$http.get(
                    `https://api-adresse.data.gouv.fr/search/?q=${this.searchText}&limit=8&type=housenumber`
                ).then(
                    response => {
                        if (response.body.features.length >= 1) {
                            this.suggeredAddress = response.body.features;
                            if (!this.open) {
                                this.open = true;
                            }
                        };
                    }
                );
            }
            this.highlightIndex = 0;
        },
        
        suggestionSelected (suggestion, index) {
            this.open = false
            this.searchText = suggestion[0]
            this.$emit('input', suggestion[1])

            this.setPosition(
                {
                    latitude: this.suggeredAddress[index - 1].geometry.coordinates[1],
                    longitude: this.suggeredAddress[index - 1].geometry.coordinates[0]
                }
            );
        },
        
        up () {
            if (this.open) {
                if (this.highlightIndex > 0) {
                    this.highlightIndex--;
                }
            } else {
                this.setOpen(true)
            }
        },
        
        down () {
             if (this.open) {
                if (this.highlightIndex < this.suggeredAddress.length) {
                    this.highlightIndex++;
                }
            } else {
                this.setOpen(true)
            }
        },

    },    
}

</script>

<style scoped>
label.address {
    margin-bottom: 0px;
}
.latlon h3 {
    margin-top: 0px;
}
span.error {
    color: #800;
    font-weight: bold;
}
button.get-gps {
    color: #888;
    padding: 5px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 110%;
    width: 32px;
}
.gmap, .leaflet-container {
    width: 100%;
    height: 300px;
    border: 12px solid white;
}
.gps-coord {
    color: #444;
}
.gps-coord table td:first-child {
    padding-right: 0.5rem;
}

.gps-coord input {
    width: 100%;
}


.dropdown {
    display: inline-block;
    position: relative;
    width: 100%;
}

.dropdown.open .suggestion-list {
    display: block;
}

.dropdown .suggestion-list {
    display: none;
}

.toggle {
    display: inline-block;
    text-decoration: none;
}

.toggle .arrow-up {
    display: none;
}

.open .toggle .arrow-up {
    display: inline-block;
}

.open .toggle .arrow-down {
    display: none;
}

.suggestion-list {
    background-color: rgba(255, 255, 255, 0.95);
    border: 1px solid #ddd;
    list-style: none;
    display: block;
    margin: 0;
    padding: 0;
    min-width: 100%;
    overflow: hidden;
    position: absolute;
    top: 49px;
    left: 0;
    z-index: 2;
    font-size: 1rem;
}

.suggestion-list li {
    cursor: pointer;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-bottom: 1px solid #eee;
}

.suggestion-list li:hover {
    color: #000;
    background-color: #eee;
}

.suggestion-list li.powered-by {
    cursor: pointer;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 0.8rem;
    color: #aaa;
    border-bottom: none;
}

.active  {
    color: #fff;
    background-color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/map.vue